import { cn } from 'utils/cn';

interface Props {
    size: 'small' | 'large';
    className?: string;
}

/** The `[G]` marker after a group's name. Its weight is inherited from the text it follows. */
const GroupIcon: React.FC<Props> = ({ size, className }) => (
    <span
        className={cn(
            'self-end',
            size === 'large'
                ? 'text-fg/30 text-[20px] leading-8'
                : 'text-fg/50 new:text-caption new:[font-weight:inherit] text-[10px] leading-5',
            className
        )}
    >
        [G]
    </span>
);

export default GroupIcon;
